import { Stack, useMediaQuery } from "@mui/material";
import MuiSkeleton from "@mui/material/Skeleton";
import { useTheme } from "@mui/material/styles";
import React, { useContext } from "react";

import { Instructor } from "../../components/Instructor/Instructor";
import { Module } from "../../components/Module/Module";
import { useViewport, View } from "../../components/Viewport/useViewport";
import { Viewport } from "../../components/Viewport/Viewport";
import { CourseContext } from "../../context/course-context";
import { useAppState } from "../../hooks/useAppState";
import { HelpAndSupport } from "./HelpAndSupport";
import { GridViewport, InlineContainer, StyledPaper } from "./Player.elements";
import { InstructorWrapper, ModuleSkeleton, ViewportSkeleton } from "./ViewportContent.elements";

export function ViewportContent(): React.ReactElement | null {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const { view } = useViewport();
  const course = useContext(CourseContext);
  const { module } = useAppState();
  const showInstructor = view !== View.Quiz && view !== View.Survey;

  const getViewportClasses = () => {
    const classes = ["viewport"];
    if (!course || !module) {
      classes.push("skeleton");
    }
    if (view === View.Quiz) {
      classes.push("fullView");
    }
    return classes.join(" ");
  };

  const getModuleWrapperClasses = () => {
    const classes = ["moduleWrapper"];
    if (!module) {
      classes.push("skeleton");
    }
    return classes.join(" ");
  };

  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <GridViewport className={getViewportClasses()}>
        {course && module ? (
          <Viewport />
        ) : (
          <ViewportSkeleton className="viewportSkeleton" animation="wave" variant="rectangular" />
        )}
      </GridViewport>
      {!isTablet && showInstructor ? (
        <StyledPaper className={getModuleWrapperClasses()}>
          {module ? (
            <>
              <Module />
              <InstructorWrapper>
                <Instructor />
                <HelpAndSupport />
              </InstructorWrapper>
            </>
          ) : (
            <ModuleSkeleton>
              <MuiSkeleton animation="wave" variant="rectangular" />
              <MuiSkeleton animation="wave" variant="rectangular" />
            </ModuleSkeleton>
          )}
        </StyledPaper>
      ) : (
        <InlineContainer className={getModuleWrapperClasses()} id="inline">
          {module ? <Module /> : null}
        </InlineContainer>
      )}
    </Stack>
  );
}
